import { render, staticRenderFns } from "./relatorio-atendimentos-televet.vue?vue&type=template&id=82f37d0e&scoped=true&"
import script from "./relatorio-atendimentos-televet.vue?vue&type=script&lang=js&"
export * from "./relatorio-atendimentos-televet.vue?vue&type=script&lang=js&"
import style0 from "./relatorio-atendimentos-televet.vue?vue&type=style&index=0&id=82f37d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f37d0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDatePicker,VDialog,VMenu,VProgressCircular,VProgressLinear,VRow,VTextField})
